import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from '@angular/fire/firestore';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {firestore} from 'firebase';
import {OtherTeam} from '../models/team.model';

@Component({
  selector: 'app-other-member',
  templateUrl: './other-member.component.html',
  styleUrls: ['./other-member.component.css']
})
export class OtherMemberComponent implements OnInit, OnDestroy {
  otherMemberRef: AngularFirestoreDocument<OtherTeam>;
  otherMemberCollectionRef: AngularFirestoreCollection<OtherTeam>;
  member: OtherTeam;

  private sub: Subscription;

  constructor(
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.otherMemberCollectionRef = this.afs.collection<OtherTeam>('other-experts');
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params.id && params.id !== 'new') {
        this.otherMemberRef = this.otherMemberCollectionRef.doc(params.id);

        this.otherMemberRef.get().subscribe((documentSnapshot: firestore.DocumentSnapshot) => {
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            this.member = {
              id: documentSnapshot.id,
              image: data.image,
              title: data.title,
              name: data.name,
              order: data.order
            };
          } else {
            this.router.navigate(['/not-found']);
          }
        });
      } else {
        this.member = {
          id: null,
          image: null,
          name: null,
          title: null,
          order: 0
        };
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  deleteMember() {
    const confirmDelete = confirm('This action is irreversible. Are you sure you want to delete the member?');
    if (confirmDelete) {
      this.otherMemberCollectionRef.doc(this.member.id).delete()
        .then(() => {
          return this.router.navigate(['/home/expertise']);
        });
    }
  }

  saveMember() {
    delete this.member.id;

    if (!this.otherMemberRef) {
      this.otherMemberCollectionRef.add(this.member)
        .then(() => {
          return this.router.navigate(['/home/expertise']);
        });
    } else {
      return this.otherMemberRef.update(this.member)
        .then(() => {
          return this.router.navigate(['/home/expertise']);
        });
    }
  }
}

